import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungSolingen() {
  return (
    <CityPageTemplate
      city="Solingen"
      slug="solingen"
      intro="Solingen als Klingenstadt – wir schneiden bei der Finanzberatung genauso präzise ab."
      description="Unabhängige & digitale Finanzberatung für Solingen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
